import { Box, Flex, Grid, IconButton, Image, Text, Drawer, DrawerBody, DrawerHeader, DrawerOverlay, DrawerContent, DrawerCloseButton, FormControl, FormLabel, Button, FormErrorMessage, useDisclosure, Select, Input, } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import EditLogo from "../../../../../assets/images/EditLogo.svg";
import { Controller, SubmitHandler, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useFetch } from "../../../../../hooks/useFetch";
import { CustomToast } from "../../../../../components";
import { EmployeePersonalInfo } from "./modal";
import { IMarital } from "./modal";
import { useAuth } from "../../../../../hooks/useAuth";
import MaritalStatusIcon from "../../../../../assets/images/Mariatal-status.svg"
interface Props {
    employeeId: number | null;
    personalDetail?: EmployeePersonalInfo;
    reload: () => void;
}

interface MaritalFormValues {
    // empId?: number | null;
    marital_Status_Id: number;
    marriage_Date?: string | null;
}

const MaritalStatus = ({ employeeId, personalDetail, reload }: Props) => {
    const { isOpen, onOpen, onClose } = useDisclosure();
    const { addToast } = CustomToast();
    const { fetchApi } = useFetch(addToast);
    const { hasPermission, loginObj } = useAuth();

    const [maritalDropdown, setMaritalDropdown] = useState<any[]>([]);


    const loggedInEmployeeId = loginObj?.employeeId;

    const isOwnProfile = employeeId === loggedInEmployeeId;

    const MaritalSchema: yup.ObjectSchema<MaritalFormValues> = yup.object({
        marital_Status_Id: yup.number().required("Marital status is required"),
        marriage_Date: yup.string().nullable()
            .transform((v) => (v === "" ? null : v))
            .when("marital_Status_Id", {
                is: 1, then: (schema) => schema.required("Marriage date is required"),
                otherwise: (schema) => schema.nullable(),
            }),
    });


    const toDateInputValue = (date?: string) => {
        if (!date) return "";
        const [day, month, year] = date.split("-");
        return `${day}-${month}-${year}`;
    };
    const { control, handleSubmit, formState: { errors, isSubmitting }, reset, watch, } = useForm<MaritalFormValues>({
        resolver: yupResolver(MaritalSchema),
        defaultValues: {
            marital_Status_Id: personalDetail?.marital_Status_Id || 0,
            marriage_Date: personalDetail?.marriage_Date
                ? toDateInputValue(personalDetail.marriage_Date)
                : null,
        },
    });

    const isMarried: number = watch("marital_Status_Id");
    const todayDate = () => new Date().toISOString().split("T")[0];

    function handleEditClick() {
        onOpen();
    }

    const onSubmit: SubmitHandler<MaritalFormValues> = async (data) => {
        const payload = {
            empId: employeeId,
            marital_Status_Id: data.marital_Status_Id,
            marriage_Date:
                data.marital_Status_Id === 1 ? data.marriage_Date : null,
        };
        const endpoint = `Hrlense_Employee/personalDetail/${employeeId}`;
        const response = await fetchApi(
            endpoint,
            "PUT",
            payload,
            null,
            "Marital Status Updated"
        );

        if (response) {
            reload();
            onClose();
        }
    };

    const fetchMaritalDropdown = async () => {
        const res = await fetchApi("DropDown/maritalStatus", "GET", null, "");
        if (res) setMaritalDropdown(res);
    };

    useEffect(() => {
        fetchMaritalDropdown();
    }, []);

    useEffect(() => {
        if (personalDetail) {
            reset({
                marital_Status_Id: personalDetail.marital_Status_Id || 0,
                marriage_Date: personalDetail.marriage_Date
                    ? personalDetail.marriage_Date.split("T")[0] : "",

            });
        }
    }, [personalDetail, reset]);

    return (
        <>

            <Box pt={2} mb={6} className="main">
                <Flex justify="space-between" align="center" mb={2} pl={5} pr={5}>
                    <Flex align="center" gap={3}>
                         <Image src={MaritalStatusIcon} alt={"maritalIcon"} />
                        <Text className="font-poppins text_sm text_medium col">
                            Marital Status
                        </Text>
                    </Flex>

                    {(hasPermission("Employee", "UpdateEmployeesMaritalStatus") || (hasPermission("Employee", "UpdateOwnMaritalStatus") && isOwnProfile)) && (
                        <IconButton
                            aria-label="Edit"
                            icon={<Image src={EditLogo} />}
                            variant="none"
                            onClick={handleEditClick}
                        />
                    )}
                </Flex>

                <Box py={2} px={10} bg="#FFFFFF" borderRadius={8}>
                    {IMarital.map((data, index) => {
                        // let value = personalDetail?.[data?.key];
                        return (
                            <Grid key={index} templateColumns="1fr 1fr" alignItems="center" mb={3}>
                            
                                <Text
                                    className="font-poppins text_sm text_medium"
                                    color="rgba(102, 102, 102, 1)"
                                   
                                >
                                    {data?.label}
                                </Text>
                                <Text className="font-poppins text_sm text_medium col">
                                    {data?.modifier
                                        ? data.modifier(personalDetail?.[data?.key])
                                        : personalDetail?.[data?.key]}
                                </Text>
                            </Grid>
                        );
                    })}
                </Box>
            </Box>

            {/* ===== EDIT DRAWER ===== */}
            <Drawer isOpen={isOpen} placement="right" onClose={onClose} size="md">
                <DrawerOverlay />
                <DrawerContent>
                    <DrawerCloseButton />
                    <DrawerHeader>Update Marital Status</DrawerHeader>
                    <DrawerBody>
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <FormControl
                                isInvalid={!!errors.marital_Status_Id}
                                isRequired
                                mb={4}
                            >
                                <FormLabel>Marital Status</FormLabel>
                                <Controller
                                    name="marital_Status_Id"
                                    control={control}
                                    render={({ field }) => (
                                        <Select {...field} placeholder="Select Marital Status"
                                            onChange={(e) => field.onChange(Number(e.target.value))}>
                                            {maritalDropdown.map((opt: any) => (
                                                <option key={opt.id} value={opt.id}>
                                                    {opt.maritalStatus}
                                                </option>
                                            ))}
                                        </Select>
                                    )}
                                />
                                <FormErrorMessage>
                                    {errors.marital_Status_Id?.message}
                                </FormErrorMessage>
                            </FormControl>

                            {isMarried === 1 && (
                                <>
                                    <FormLabel> Anniversary Date</FormLabel>
                                    <FormControl
                                        isInvalid={!!errors.marriage_Date}
                                        isRequired
                                        mb={4}
                                    >
                                        <Controller
                                            name="marriage_Date" control={control}
                                            render={({ field }) => (
                                                <Input type="date" value={field.value ?? ""} onChange={field.onChange} max={todayDate()} />
                                            )}
                                        />
                                        <FormErrorMessage>
                                            {errors.marriage_Date?.message}
                                        </FormErrorMessage>
                                    </FormControl>
                                </>
                            )}

                            <Box mt={6} textAlign="right">
                                <Button
                                    type="submit"
                                    className="btn_theme btn_theme:hover"
                                    isLoading={isSubmitting}
                                >
                                    Update
                                </Button>
                            </Box>
                        </form>
                    </DrawerBody>
                </DrawerContent>
            </Drawer>
        </>
    );
};

export default MaritalStatus;

